import { type RouteRecordRaw } from 'vue-router';

import LoginPage from '@/view/auth/LoginPage.vue';
import ForgotPasswordPage from '@/view/auth/ForgotPasswordPage.vue';
import OtpPage from '@/view/auth/OtpPage.vue';
import ResetSuccessPage from '@/view/auth/ResetSuccessPage.vue';
import DashboardPage from '@/view/dashboard/DashboardPage.vue';
import TermsPage from '@/view/TermsPage.vue';
import ThemeSettingsPage from '@/view/settings/ThemeSettingsPage.vue';
import NotificationsSettingsPage from '@/view/settings/NotificationsSettingsPage.vue';
import TermsSettingsPage from '@/view/settings/TermsSettingsPage.vue';
import PaymentConfigPage from '@/view/settings/PaymentConfigPage.vue';
import NotificationsPage from '@/view/notifications/NotificationsPage.vue';
import CommandesPage from '@/view/commandes/CommandesPage.vue';
import OrderDetailPage from '@/view/commandes/OrderDetailPage.vue';
import AnalyticsPage from '@/view/analytics/AnalyticsPage.vue';
import CommercesPage from '@/view/commerces/CommercesPage.vue';
import CreateCommercePage from '@/view/commerces/CreateCommercePage.vue';
import EditCommercePage from '@/view/commerces/EditCommercePage.vue';
import TraductionsPage from '@/view/commerces/TraductionsPage.vue';
import CommerceAvailabilityPage from '@/view/commerces/CommerceAvailabilityPage.vue';
import CommerceDetailPage from '@/view/commerces/CommerceDetailPage.vue';
import ClientsPage from '@/view/clients/ClientsPage.vue';
import CreateClientPage from '@/view/clients/CreateClientPage.vue';
import EditClientPage from '@/view/clients/EditClientPage.vue';
import ClientDetailPage from '@/view/clients/ClientDetailPage.vue';
import CollectionsPage from '@/view/collections/CollectionsPage.vue';
import AllCollectionsPage from '@/view/collections/AllCollectionsPage.vue';
import CreatePromotionPage from '@/view/promotions/CreatePromotionPage.vue';
import CreateProductPage from '@/view/products/CreateProductPage.vue';
import EditProductPage from '@/view/products/EditProductPage.vue';
import ProductDetailPage from '@/view/products/ProductDetailPage.vue';
import NotFoundPage from '@/view/NotFoundPage.vue';
import UsersRolesPage from '@/view/users/UsersRolesPage.vue';
import UserManagementPage from '@/view/users/UserManagementPage.vue';
import UserDetailPage from '@/view/users/UserDetailPage.vue';
import MediasPage from '@/view/medias/MediasPage.vue';
import MediaDetailPage from '@/view/medias/MediaDetailPage.vue';
import ModulesManagementPage from '@/view/modules/ModulesManagementPage.vue';
import PaymentsManagementPage from '@/view/payments/PaymentsManagementPage.vue';
import PaymentDetailPage from '@/view/payments/PaymentDetailPage.vue';
import PaymentReconciliationPage from '@/view/payments/PaymentReconciliationPage.vue';
import EquipmentPage from '@/view/equipment/EquipmentPage.vue';

declare module 'vue-router' {
  interface RouteMeta {
    requiresAuth?: boolean;
    layout?: 'app' | 'auth' | 'blank';
  }
}

const admin_router: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { layout: 'auth' },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordPage,
    meta: { layout: 'auth' },
  },
  {
    path: '/otp',
    name: 'Otp',
    component: OtpPage,
    meta: { layout: 'auth' },
  },
  {
    path: '/reset-success',
    name: 'ResetSuccess',
    component: ResetSuccessPage,
    meta: { layout: 'auth' },
  },
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/terms',
    name: 'Terms',
    component: TermsPage,
    meta: { layout: 'blank' },
  },
  {
    path: '/settings/theme',
    name: 'SettingsTheme',
    component: ThemeSettingsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/settings/notifications',
    name: 'SettingsNotifications',
    component: NotificationsSettingsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/settings/terms',
    name: 'SettingsTerms',
    component: TermsSettingsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/settings/payment',
    name: 'SettingsPayment',
    component: PaymentConfigPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: NotificationsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/commandes',
    name: 'Commandes',
    component: CommandesPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/commandes/:id',
    name: 'OrderDetail',
    component: OrderDetailPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: AnalyticsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/commerces',
    name: 'Commerces',
    component: CommercesPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/commerces/new',
    name: 'CommerceNew',
    component: CreateCommercePage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/commerces/:id/edit',
    name: 'CommerceEdit',
    component: EditCommercePage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/commerces/traductions',
    name: 'CommerceTraductions',
    component: TraductionsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/commerces/disponibilite',
    name: 'CommerceAvailability',
    component: CommerceAvailabilityPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/commerces/:id',
    name: 'CommerceDetail',
    component: CommerceDetailPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/clients',
    name: 'Clients',
    component: ClientsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/clients/new',
    name: 'ClientNew',
    component: CreateClientPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/clients/:id/edit',
    name: 'ClientEdit',
    component: EditClientPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/clients/:id',
    name: 'ClientDetail',
    component: ClientDetailPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/collections',
    name: 'Collections',
    component: CollectionsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/collections/toutes',
    name: 'AllCollections',
    component: AllCollectionsPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/promotions/new',
    name: 'PromotionNew',
    component: CreatePromotionPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/products/new',
    name: 'ProductNew',
    component: CreateProductPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/products/:id/edit',
    name: 'ProductEdit',
    component: EditProductPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: ProductDetailPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/users-roles',
    name: 'UsersRoles',
    component: UsersRolesPage,
    meta: { layout: 'app' },
  },
  {
    path: '/gestion-utilisateurs',
    name: 'UserManagement',
    component: UserManagementPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/gestion-utilisateurs/:id',
    name: 'UserDetail',
    component: UserDetailPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/medias',
    name: 'Medias',
    component: MediasPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/medias/:id',
    name: 'MediaDetail',
    component: MediaDetailPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/gestion-modules',
    name: 'ModulesManagement',
    component: ModulesManagementPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/equipements',
    name: 'Equipment',
    component: EquipmentPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/gestion-paiement',
    name: 'PaymentsManagement',
    component: PaymentsManagementPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/gestion-paiement/reconciliation',
    name: 'PaymentReconciliation',
    component: PaymentReconciliationPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/gestion-paiement/:id',
    name: 'PaymentDetail',
    component: PaymentDetailPage,
    meta: { requiresAuth: true, layout: 'app' },
  },
  {
    path: '/admin',
    redirect: '/',
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: { layout: 'blank' },
  },
];

export default admin_router;
